import React from 'react';

import type { useNumberIncrementHandler } from '@travel/traveler-core/components/AmountInput/hooks';
import { useDeviceType, MOBILE_SCREEN } from '@travel/traveler-core/hooks';
import { cx } from '@travel/utils';

import labels from 'favoriteList/components/SearchForm/constants/labels';
import CounterForm from './CounterForm';

import styles from './amountInput.module.scss';

type RoomInputProps = {
  rooms: ReturnType<typeof useNumberIncrementHandler>;
  incrementIcon: React.ReactElement;
  decrementIcon: React.ReactElement;
};

export function RoomInput(props: RoomInputProps) {
  const { rooms, decrementIcon, incrementIcon } = props;
  const isSP = useDeviceType() === MOBILE_SCREEN;
  return (
    <>
      {!isSP && (
        <div className={styles.sectionTitle}>
          <span>{labels.numberOfRooms}</span>
        </div>
      )}
      <div
        className={cx(styles.amountFormContainer, styles.amountWrapper, styles.roomAmountWrapper)}
      >
        <p className={cx(styles.textWrapper, styles.amountTitle)}>
          <span>{isSP ? labels.numberOfRooms : labels.rooms}</span>
        </p>
        <CounterForm
          {...rooms}
          counterType="room"
          decrementIcon={decrementIcon}
          incrementIcon={incrementIcon}
          isCounterBolded
          counterText={isSP ? labels.rooms : undefined}
        />
      </div>
    </>
  );
}

export default RoomInput;
